const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnRecordXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1353",
    d: "M601.068 224.193a4.406 4.406 0 0 1 0-8.813 4.564 4.564 0 0 1 3.117 1.287 4.375 4.375 0 0 1 1.294 3.114 4.411 4.411 0 0 1-4.411 4.412zm0-6.917a2.51 2.51 0 1 0 2.513 2.51 2.51 2.51 0 0 0-2.51-2.507z",
    transform: "translate(-589.064 -207.788)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1354",
    d: "M600.587 228.309a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9zm0-16.148a7.148 7.148 0 1 0 7.147 7.148 7.156 7.156 0 0 0-7.147-7.148z",
    style: {
      fill: "current"
    },
    transform: "translate(-588.586 -207.31)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRecordXs);
export default __webpack_public_path__ + "static/media/btn-record-xs.43059e5fdcce567bea2d57d1802c6058.svg";
export { ForwardRef as ReactComponent };